export default {
  label: {
    title: {
      noCardsSelected: 'No component added to the dashboard',
    },
    button: {
      addChartButton: 'Add component',
    },
  },
};
